import React from 'react';

const VerificationBadge = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={26}
      height={26}
      viewBox='0 0 26 26'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_27647_45746)'>
        <path
          d='M25.1875 13C25.1875 14.04 23.9098 14.8972 23.6539 15.8559C23.3898 16.8472 24.0581 18.2284 23.5564 19.0958C23.0466 19.9773 21.513 20.083 20.798 20.798C20.083 21.513 19.9773 23.0466 19.0958 23.5564C18.2284 24.0581 16.8472 23.3898 15.8559 23.6539C14.8972 23.9098 14.04 25.1875 13 25.1875C11.96 25.1875 11.1028 23.9098 10.1441 23.6539C9.15281 23.3898 7.77156 24.0581 6.90422 23.5564C6.02266 23.0466 5.91703 21.513 5.20203 20.798C4.48703 20.083 2.95344 19.9773 2.44359 19.0958C1.94187 18.2284 2.61016 16.8472 2.34609 15.8559C2.09016 14.8972 0.8125 14.04 0.8125 13C0.8125 11.96 2.09016 11.1028 2.34609 10.1441C2.61016 9.15281 1.94187 7.77156 2.44359 6.90422C2.95344 6.02266 4.48703 5.91703 5.20203 5.20203C5.91703 4.48703 6.02266 2.95344 6.90422 2.44359C7.77156 1.94187 9.15281 2.61016 10.1441 2.34609C11.1028 2.09016 11.96 0.8125 13 0.8125C14.04 0.8125 14.8972 2.09016 15.8559 2.34609C16.8472 2.61016 18.2284 1.94187 19.0958 2.44359C19.9773 2.95344 20.083 4.48703 20.798 5.20203C21.513 5.91703 23.0466 6.02266 23.5564 6.90422C24.0581 7.77156 23.3898 9.15281 23.6539 10.1441C23.9098 11.1028 25.1875 11.96 25.1875 13Z'
          fill='url(#paint0_linear_27647_45746)'
        />
        <g filter='url(#filter0_d_27647_45746)'>
          <path
            d='M16.5231 9.36809L11.8838 14.0075L9.47875 11.6045C8.95672 11.0825 8.10969 11.0825 7.58766 11.6045C7.06563 12.1265 7.06563 12.9736 7.58766 13.4956L10.9616 16.8695C11.4694 17.3773 12.2941 17.3773 12.8019 16.8695L18.4122 11.2592C18.9342 10.7371 18.9342 9.89012 18.4122 9.36809C17.8902 8.84605 17.0452 8.84605 16.5231 9.36809Z'
            fill='white'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_d_27647_45746'
          x='4.52947'
          y='8.97656'
          width='16.9409'
          height='13.6068'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2.66667' />
          <feGaussianBlur stdDeviation='1.33333' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_27647_45746'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_27647_45746'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_27647_45746'
          x1={13}
          y1='0.8125'
          x2={13}
          y2='25.1875'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F9742C' />
          <stop offset={1} stopColor='#F20486' />
        </linearGradient>
        <clipPath id='clip0_27647_45746'>
          <rect width={26} height={26} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VerificationBadge;
